export default __webpack_public_path__ + "static/media/on-progress.374dc540.jpg";